import { SyncOutlined } from '@ant-design/icons';
import { Button, message, Popconfirm, Tooltip } from 'antd';
import React, { useState } from 'react';

import { fetchAPI } from '../../utils/api';

const OrderSyncSMEPODocuments = (props: {
  orderId: number;
  onSuccess: () => Promise<void>;
  hasAttachmentPO: boolean;
}) => {
  const [loading, setLoading] = useState(false);

  const downloadSMEDocuments = async () => {
    setLoading(true);
    try {
      await fetchAPI('external/order/get-sme-po-attachment', {
        method: 'POST',
        payload: {
          order_id: props.orderId,
          force_update: 0,
          is_debug: 0,
        },
      });
      message.success('PO Documents Synced!');
      await props.onSuccess();
    } catch (error) {
      message.error('Failed get SME PO Documents');
      if (error.message) {
        message.error(error.message);
      }
    }
    setLoading(false);
  };

  if (!!props.hasAttachmentPO) {
    return (
      <Tooltip title="Order already have PO Documents">
        <Button
          icon={<SyncOutlined />}
          loading={loading}
          disabled
          style={{ margin: '15px 0 0 0' }}
        >
          Sync SME PO Documents
        </Button>
      </Tooltip>
    );
  }

  return (
    <Popconfirm
      title={
        'Syncing Documents will reset the form, make sure your changes is already saved'
      }
      onConfirm={() => {
        downloadSMEDocuments();
      }}
    >
      <Button
        icon={<SyncOutlined />}
        loading={loading}
        style={{ margin: '15px 0 0 0' }}
      >
        Sync SME PO Documents
      </Button>
    </Popconfirm>
  );
};

export default OrderSyncSMEPODocuments;
